import { REMOVE_STORE, STORE_LIST } from './actionTypes';

const initialState = {
  stores: []
};

export default (state = initialState, action) => {
  switch (action.type) {
    case REMOVE_STORE:
      const newStateObj = state;
      delete newStateObj[action.id];

      return newStateObj;
    case STORE_LIST:
      return Object.assign({}, state, { stores: action.stores });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/storesReducer.js